import { RegionType, type Suggestion } from "@b2bportal/air-shopping-api";
import {
  IdEnum,
  type IIdFlight,
  type ITripTerminus,
} from "@b2bportal/core-types";

export const locationCodeToITripTerminus = (
  code: string,
  regionType = RegionType.airport
): ITripTerminus => ({
  id: {
    Id: IdEnum.Flight,
    code: {
      code,
      regionType,
    },
  },
  label: code,
  trackingProperties: {},
});

export const suggestionToITripTerminus = (
  suggestion?: Suggestion
): ITripTerminus | undefined =>
  suggestion
    ? {
        id: suggestion.id as IIdFlight,
        label: suggestion.label,
        trackingProperties: suggestion.trackingPropertiesV2,
      }
    : undefined;
export const terminusToSuggestion = (
  term?: ITripTerminus
): Suggestion | undefined =>
  term
    ? {
        trackingPropertiesV2: term.trackingProperties,
        label: term.label,
        id: term.id,
      }
    : undefined;
